export default __webpack_public_path__ + "media/svgs/search-c943a262.svg";